import {
  useContext,
  useEffect,
  useState,
  useReducer,
  useRef,
  createContext,
} from "react";
import ReactPlayer from "react-player";
import styles from "./index.module.scss";
import NavHeader from "../../components/NavHeader";
import SidePaneContainer from "../../components/SidePaneContainer";
import {
  Box,
  Circle,
  ContainerBox,
  Line,
  Shimmer,
} from "../../components/ShimmerEffect";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import PollsNQnA from "./partials/PollsNQnA";
import ContactFooter from "../../components/ContactFooter";
import WebinarHeader from "./partials/WebinarHeader";
import WebinarTabs from "./partials/WebinarTabs";
import WebinarHeadCard from "./partials/WebinarHeadCard";
import { useHistory, useLocation, useParams } from "react-router-dom";
import LoaderImg from "../../assets/images/videoLoader.gif";
import QNAImg from "../../assets/images/Q&A.png";
import { firestore } from "../../firebase/firebase";
import { WEBINAR_COLLECTION } from "../../AppConstants/CollectionConstants";
import { URLADMIN } from "../../AppConstants/TypeConstants";
import { filterNullObjectKeys, loadImageAsync } from "../../utils/common.utils";
import {
  LIVESTREAM_status,
  Webinar_status,
  SourceType,
} from "../../AppConstants/TypeConstants";
import { ChatBot, MuxVideoPlayer } from "../../components";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import { THEME } from "../../AppConstants/ThemeConstant";
import { VideoPlayerContext } from "../../contexts/VideoPlayerContext/VideoPlayerContextProvider";
import { showToast } from "../../utils/common.utils";
import firebase from "../../firebase/firebase";
import {
  addUserLoginHook,
  UserLoginHookActionType,
} from "../../utils/UserLoginHook";
import { webinarContext } from "../../contexts/WebinarContext/WebinarContextProvider";
import WebinarManager from "../../Managers/webinar";
import useQuery from "../../utils/useQuery";
import InteractionContainer from "./partials/InteractionContainer/InteractionContainer";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import OTPForm from "../../components/Signup/partials/OTPForm/OTPForm";
import { getUserActiveStatus, user_ActiveStatus } from "../../Managers/Chat";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import { WEBINAR_REGISTER } from "../../AppConstants/AnalyticsEventName";
import { networkContext } from "../../contexts/NetworkContext/NetworkContextProvider";
import { WEBINAR_PAGE_ROUTE } from "../../AppConstants/Routes";
import {
  AGENDA_CHANGED_EVENT,
  WEBINAR_COMPLETED_EVENT,
  WEBINAR_JOINED_EVENT,
  WEBINAR_QUITED_EVENT,
  WEBINAR_REGISTERATION_EVENT,
} from "../../Clevertap/EventNames.ts";
import {
  getAgendaData,
  getWebinarClickData,
  getWebinarRegisterData,
} from "../../Clevertap/EventHandler.ts";
import { usersAPI } from "../../apis/usersAPI.js";
import ScoreManager from "../../Managers/ScoringManager/post.js";
const WebinarPageContext = createContext([]);
//#region STATE
export const WEBINAR_PAGE_ACTIONS = {
  UPDATE_BASE_INFO: 0,
  UPDATE_AGENDA: 1,
  UPDATE_SPEAKERS: 2,
  UPDATE_DETAILS: 3,
  UPDATE_RESOURCES: 4,
  UPDATE_REGISTRATION_STATUS: 5,
  handleUTM: 6,
};

export const WEBINAR_Registeration_Status = {
  notRegistered: -1,
  checking: 0,
  Registered: 1,
};
const WEBINART_INITAL_STATE = {
  baseInfo: null,
  agenda: null,
  speakers: null,
  details: null,
  resources: null,
  utm_source: "",
  utm_medium: "",
  utm_campaign: "",

  registerationStatus: WEBINAR_Registeration_Status.checking,
};

const reducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case WEBINAR_PAGE_ACTIONS.UPDATE_BASE_INFO:
      return { ...state, baseInfo: payload };
    case WEBINAR_PAGE_ACTIONS.UPDATE_AGENDA:
      return { ...state, agenda: payload };
    case WEBINAR_PAGE_ACTIONS.UPDATE_SPEAKERS:
      return { ...state, speakers: payload };
    case WEBINAR_PAGE_ACTIONS.UPDATE_DETAILS:
      return { ...state, details: payload };
    case WEBINAR_PAGE_ACTIONS.UPDATE_RESOURCES:
      return { ...state, resources: payload };
    case WEBINAR_PAGE_ACTIONS.UPDATE_REGISTRATION_STATUS:
      return { ...state, registerationStatus: payload };
    case WEBINAR_PAGE_ACTIONS.handleUTM:
      return { ...state, ...payload };
    default:
      return { ...state };
  }
};

export const useWebinarPageContext = () => useContext(WebinarPageContext);
//#endregion

function WebinarDetails() {
  const { webinarID } = useParams();
  const { pathname, search = "", hash = "" } = useLocation();
  const query = useQuery();
  let admin = query.get("admin");
  let preview = query.get("preview");
  const history = useHistory();
  const [state, dispatch] = useReducer(reducer, WEBINART_INITAL_STATE);
  const docListenerRef = useRef(null);
  const isScoreGiven = useRef(false);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const { toggleSignInbtn, state: newAuthState } = useContext(authContext);
  const { showOTPModal } = newAuthState;
  const { addWebinarTimespent, updateUserStateInWebinar } =
    useContext(webinarContext);
  const [speedControlOpen, setSpeedControlOpen] = useState(false);
//   console.log("speedControlOpen", speedControlOpen);

  const muxVideoRef = useRef("");
  const { isFullScreen } = useContext(VideoPlayerContext);
  const { setWebinarDetails } = useContext(networkContext);
  const { user, userMetadata, userBasicDetails } = useContext(UserContext);
  const agendas = useRef({
    previousAgenda: null,
    currentAgenda: null,
  });
  const [isvideoLoading, setIsVideoLoading] = useState(true);

  // for QNA & POLL
  const [isOpen, setIsOpen] = useState(isMobileDevice ? false : true);
  const [showDefaultTabPolls, setShowDefaultTabPolls] = useState(false);

  const [showPollIndicator, setPollIndicator] = useState(false);
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);

  useEffect(() => {
    let decodedSearch = decodeURIComponent(search);
    let returnURL = new URLSearchParams(decodedSearch).get("returnURL");
    let obj = {
      utm_source: new URLSearchParams(decodedSearch).get("utm_source"),
      utm_medium: new URLSearchParams(decodedSearch).get("utm_medium"),
      utm_campaign: new URLSearchParams(decodedSearch).get("utm_campaign"),
    };
    if (returnURL) {
      let utm_source = new URLSearchParams(
        decodeURIComponent(returnURL?.split("?")[1])
      ).get("utm_source");
      obj["utm_source"] = utm_source;
    }

    dispatch({
      type: WEBINAR_PAGE_ACTIONS.handleUTM,
      payload: obj,
    });
  }, [search]);

  useEffect(() => {
    if (!userMetadata) {
      dispatch({
        type: WEBINAR_PAGE_ACTIONS.UPDATE_REGISTRATION_STATUS,
        payload: WEBINAR_Registeration_Status.notRegistered,
      });
      return;
    }
    if (userMetadata?.id && userMetadata?.webinars) {
      const isRegistered = userMetadata.webinars.indexOf(webinarID) !== -1;
      dispatch({
        type: WEBINAR_PAGE_ACTIONS.UPDATE_REGISTRATION_STATUS,
        payload: isRegistered
          ? WEBINAR_Registeration_Status.Registered
          : WEBINAR_Registeration_Status.notRegistered,
      });
    }
  }, [userMetadata?.webinars]);

  useEffect(() => {
    if (
      user?.uid &&
      state.baseInfo?.status === Webinar_status.ONGOING &&
      !isScoreGiven.current
    ) {
      try {
        isScoreGiven.current = true;
        ScoreManager.watchedWebinar(webinarID, user?.uid);
      } catch (error) {
        console.error(error);
      }
    }
  }, [user?.uid, state.baseInfo?.status]);

  useEffect(() => {
    if (webinarID) {
      fetchBaseInfo(webinarID);
    } else {
      redirectToHome();
    }
    return () => docListenerRef.current();
  }, [webinarID]);

  useEffect(() => {
    if (user && webinarID) {
      //set the disconnection status function
      user_ActiveStatus(user, webinarID);
    }
  }, [webinarID, user?.uid]);

  useEffect(() => {
    if (admin === URLADMIN.admin) {
      return;
    }
    if (!user || !state.baseInfo) {
      return;
    } else {
      if (state.baseInfo.ongoingagendaid && state.agenda) {
        let agendaDetails = state.agenda.mainData.filter(
          (d) => d.id === state.baseInfo.ongoingagendaid
        )[0];
        addCleverTapAnalytics(
          AGENDA_CHANGED_EVENT,
          getAgendaData({
            ...agendaDetails,
            "Webinar Title": state.baseInfo.title,
          })
        );
      }
    }
  }, [state.baseInfo?.ongoingagendaid, state.agenda]);

  useEffect(() => {
    if (admin === URLADMIN.admin) {
      return;
    }
    if (!user || !state.baseInfo) {
      return;
    }
    if (state.baseInfo.status === Webinar_status.ENDED) {
      addCleverTapAnalytics(
        WEBINAR_COMPLETED_EVENT,
        getWebinarClickData(state.baseInfo)
      );
    }
    return () => {
      if (!user || admin === URLADMIN.admin) {
        return;
      }

      if (state.baseInfo.status === Webinar_status.ONGOING) {
        addCleverTapAnalytics(
          WEBINAR_JOINED_EVENT,
          getWebinarClickData(state.baseInfo)
        );
      }

      if (
        state.baseInfo.status === Webinar_status.ENDED ||
        state.baseInfo.status === Webinar_status.ONGOING
      ) {
        addCleverTapAnalytics(
          WEBINAR_QUITED_EVENT,
          getWebinarClickData(state.baseInfo)
        );
      }

      if (state.baseInfo.status === Webinar_status.ONGOING) {
        addWebinarTimespent(
          user?.uid,
          state.baseInfo.id,
          agendas.current.currentAgenda,
          null,
          state.baseInfo.status,
          false
        );
      }
    };
  }, [state?.baseInfo?.status]);

  useEffect(() => {
    if (admin === URLADMIN.admin) {
      return;
    }
    if (!user?.uid || !state.baseInfo) {
      return;
    } else {
      if (state.baseInfo.status === Webinar_status.ONGOING) {
        agendas.current = {
          previousAgenda: agendas.current?.currentAgenda || null,
          currentAgenda: state.baseInfo.ongoingagendaid,
        };
      }
      if (
        state.baseInfo.status === Webinar_status.ONGOING ||
        state.baseInfo.status === Webinar_status.ENDED
      ) {
        addWebinarTimespent(
          user.uid,
          state.baseInfo.id,
          agendas.current.previousAgenda,
          state.baseInfo.ongoingagendaid,
          state.baseInfo.status,
          false
        );
      }
    }
  }, [user?.uid, state.baseInfo?.ongoingagendaid, state.baseInfo?.status]);

  useEffect(() => {
    if (admin === URLADMIN.admin) {
      return;
    }
    if (!userBasicDetails || !state.baseInfo) {
      return;
    } else {
      let userState = userBasicDetails.state ? userBasicDetails.state : null;
      if (state.baseInfo.status === Webinar_status.ONGOING) {
        // update user status
        updateUserStateInWebinar(
          userBasicDetails.uid,
          userState,
          state.baseInfo.id,
          "online"
        );
      }
      if (state.baseInfo.status === Webinar_status.ENDED) {
        // update user status
        updateUserStateInWebinar(
          userBasicDetails.uid,
          userState,
          state.baseInfo.id,
          "offline"
        );
      }
    }
    return () => {
      if (admin === URLADMIN.admin) {
        return;
      }
      if (userBasicDetails) {
        let userState = userBasicDetails.state ? userBasicDetails.state : null;
        if (
          state.baseInfo.status === Webinar_status.ENDED ||
          state.baseInfo.status === Webinar_status.ONGOING
        ) {
          updateUserStateInWebinar(
            userBasicDetails.uid,
            userState,
            state.baseInfo.id,
            "offline"
          );
        }
      }
    };
  }, [userBasicDetails?.state, state.baseInfo?.status]);

  // useEffect(()=>{
  //   console.log(showDefaultTabPolls);
  //   if(showDefaultTabPolls){
  //     setIsOpen(true)
  //   }
  // },[showDefaultTabPolls])

  const fetchBaseInfo = async (webinarID) => {
    let docRef = firestore.collection(WEBINAR_COLLECTION).doc(webinarID);
    docListenerRef.current = docRef.onSnapshot(async (doc) => {
      if (!doc.exists) {
        redirectToHome();
      }

      let _data = doc.data();

      _data["videos"] = {};

      const videoDocRef = await firestore
        .collection(WEBINAR_COLLECTION)
        .doc(webinarID)
        .collection("videos")
        .get();

      if (!videoDocRef.empty) {
        videoDocRef.docs.forEach((doc) => {
          _data["videos"][doc.id] = doc.data();
        });
      }

      if (
        _data.status === Webinar_status.DISABLED &&
        admin !== URLADMIN.admin
      ) {
        redirectToHome();
      } else {
        // if (_data.thumbnailUrl) {
        //   await loadImageAsync(_data.thumbnailUrl);
        // }
        setWebinarDetails(_data);
        document.title = `${_data.title} | Webinar | Docflix – OTT platform for doctors`;
        dispatch({
          type: WEBINAR_PAGE_ACTIONS.UPDATE_BASE_INFO,
          payload: _data,
        });
        // setDurationObj(getTime(new Date(_data.startTime)));
      }
    });
  };
  const redirectToHome = () => {
    return history.push({ pathname: WEBINAR_PAGE_ROUTE, search: search });
  };

  const handleBookyourSpotBtn = async (webinarID, slotId, prerequisite) => {
    let extraData = { Status: false, message: "" };
    try {
      if (user) {
        dispatch({
          type: WEBINAR_PAGE_ACTIONS.UPDATE_REGISTRATION_STATUS,
          payload: WEBINAR_Registeration_Status.checking,
        });
        let obj = {
          eventId: webinarID,
          utm_source: state.utm_source,
          utm_medium: state.utm_medium,
          utm_campaign: state.utm_campaign,
        };
        if (slotId) {
          obj["slotId"] = slotId;
        }
        if (prerequisite) {
          obj["prerequisite"] = prerequisite;
        }
        const res = await usersAPI.webinarRegister(filterNullObjectKeys(obj));
        if (res.data.status == "Successfull") {
          showToast("Registration successful!");
          extraData["Status"] = true;
          addCleverTapAnalytics(
            WEBINAR_REGISTERATION_EVENT,
            getWebinarRegisterData({ ...state.baseInfo, ...extraData })
          );
          addGAWithUserInfo(WEBINAR_REGISTER, {
            ...obj,
            userID: user.uid,
          });
        }
        document.dispatchEvent(
          new CustomEvent("user-reg:webinar", {
            detail: { webinar: webinarID },
          })
        );
      } else {
        //open register
        let obj = {
          eventId: webinarID,
          automation: true,
          utm_source: state.utm_source,
          utm_medium: state.utm_medium,
          utm_campaign: state.utm_campaign,
        };
        if (slotId) {
          obj["slotId"] = slotId;
        }
        if (prerequisite) {
          obj["prerequisite"] = prerequisite;
        }

        function eventPush(obj) {
          addCleverTapAnalytics(
            WEBINAR_REGISTERATION_EVENT,
            getWebinarRegisterData({ ...state.baseInfo, ...extraData, ...obj })
          );
        }
        addUserLoginHook(UserLoginHookActionType.WEBINAR_REGISTER, {
          data: filterNullObjectKeys(obj),
          fn: eventPush,
        });
        localStorage.setItem("registeration_source", webinarID);
        toggleSignInbtn("showSignInModal", true);
      }
    } catch (error) {
      const { data: err } = error;
      extraData["Status"] = false;
      extraData["message"] = err.message;
      addCleverTapAnalytics(
        WEBINAR_REGISTERATION_EVENT,
        getWebinarRegisterData({ ...state.baseInfo, ...extraData })
      );
    }
  };

  let timeInterval = null;
  const handleMouseHoverOnVideo = (e) => {
    if (!showVideoOverlay) {
      if (timeInterval) {
        clearInterval(timeInterval);
        timeInterval = null;
      }
      setShowVideoOverlay(true);
      timeInterval = setTimeout(() => {
        setShowVideoOverlay(false);
      }, 6000);
    }
  };

  const handleMouseLeaveOnVideo = (e) => {
    if (showVideoOverlay) {
      clearInterval(timeInterval);
      timeInterval = null;
      setShowVideoOverlay(false);
    }
  };

  const closeStartWatchingBtn = () => {};
  const handleVideoLoading = (bool) => {
    setIsVideoLoading(bool);
  };
  const showLivePlayer =
    (state.baseInfo &&
      admin !== URLADMIN.admin &&
      state.baseInfo.status === Webinar_status.ONGOING &&
      state.registerationStatus === WEBINAR_Registeration_Status.Registered) ||
    (state.baseInfo &&
      admin === URLADMIN.admin &&
      URLADMIN.previewEvent === preview);

  return showOTPModal && admin !== URLADMIN.admin ? (
    <div className={`modalOverlayWithBlur ${styles["OTPContainer"]}`}>
      {userBasicDetails && (
        <div className={styles.box}>
          <OTPForm data={{ phoneNumber: userBasicDetails.phoneNumber }} />
        </div>
      )}
    </div>
  ) : (
    <WebinarPageContext.Provider value={{ webinarID, state, dispatch }}>
      <div className={styles.webinarDetails}>
        <NavHeader
          scrollValue={30}
          defaultBg={"#000"}
          themeConstant
          showNav={false}
          showBreadcrum
          eventDetails={state.baseInfo ? state.baseInfo : null}
          nativeBack
        />

        <div
          id="pageData"
          className={styles.pageData}
          style={
            admin === URLADMIN.admin
              ? {
                  paddingTop: isFullScreen
                    ? 0
                    : state.baseInfo && URLADMIN.previewRegistration === preview
                    ? "11.5625rem"
                    : state.baseInfo && URLADMIN.previewEvent === preview
                    ? "5rem"
                    : state.baseInfo &&
                      state.baseInfo.archieveVideo &&
                      state.baseInfo.archieveVideo.show &&
                      state.baseInfo.status === Webinar_status.ENDED
                    ? "5rem"
                    : "5.5rem",
                  position: isFullScreen && "relative",
                  zIndex: isFullScreen && 9,
                }
              : {
                  paddingTop: isFullScreen
                    ? 0
                    : state.baseInfo &&
                      state.baseInfo.status === Webinar_status.REGISTERATION
                    ? "11.5625rem"
                    : state.baseInfo &&
                      state.baseInfo.status === Webinar_status.ONGOING
                    ? "5rem"
                    : state.baseInfo &&
                      state.baseInfo.archieveVideo &&
                      state.baseInfo.archieveVideo.show &&
                      state.baseInfo.status === Webinar_status.ENDED
                    ? "5rem"
                    : "5.5rem",
                  position: isFullScreen && "relative",
                  zIndex: isFullScreen && 9,
                }
          }
        >
          <Shimmer
            loading={!state.baseInfo}
            loadingComponent={
              <div
                style={{
                  height: !isMobileDevice ? "375px" : "280px",
                  width: !isMobileDevice ? "80vw" : "100%",
                  padding: !isMobileDevice ? "0 10%" : 0,
                  marginBottom: !isMobileDevice ? "12rem" : "270px",
                  paddingTop: !isMobileDevice && "0rem",
                }}
              >
                <ContainerBox>
                  <div
                    style={{
                      position: "absolute",
                      bottom: isMobileDevice ? "-80%" : "-35%",
                      left: "50%",
                      transform: isMobileDevice
                        ? "translate(-50%, 0%)"
                        : "translate(-50%, 0%)",
                      width: isMobileDevice ? "85%" : "50%",
                    }}
                  >
                    <Box height={isMobileDevice ? 500 : 180} width={"100%"} />
                  </div>
                </ContainerBox>
              </div>
            }
            renderComponent={
              <>
                {state.baseInfo &&
                  (state.baseInfo.status === Webinar_status.REGISTERATION ||
                    state.baseInfo.status === Webinar_status.ENDED ||
                    (state.baseInfo.status === Webinar_status.ONGOING &&
                      state.registerationStatus ===
                        WEBINAR_Registeration_Status.notRegistered)) &&
                  admin !== URLADMIN.admin && (
                    <WebinarHeadCard
                      setSpeedControlOpen={setSpeedControlOpen}
                      eventDetails={state.baseInfo}
                      registerationStatus={state.registerationStatus}
                      handleBookyourSpotBtn={handleBookyourSpotBtn}
                      isEventLive={
                        state.baseInfo.status === Webinar_status.ONGOING
                      }
                    />
                  )}
                {/* for cms view start*/}
                {state.baseInfo &&
                  admin === URLADMIN.admin &&
                  URLADMIN.previewRegistration === preview && (
                    <WebinarHeadCard
                      setSpeedControlOpen={setSpeedControlOpen}
                      eventDetails={state.baseInfo}
                      registerationStatus={state.registerationStatus}
                      handleBookyourSpotBtn={handleBookyourSpotBtn}
                      isEventLive={
                        state.baseInfo.status === Webinar_status.ONGOING
                      }
                    />
                  )}
                {/* for cms view end*/}
              </>
            }
          />
          {showLivePlayer && (
            <>
              <SidePaneContainer
                mainComponent={
                  <div
                    className={styles.videoSide}
                    onMouseMove={handleMouseHoverOnVideo}
                    onMouseLeave={handleMouseLeaveOnVideo}
                  >
                    {isvideoLoading && (
                      <div className="videoLoader">
                        <img src={LoaderImg} alt="" height="100%" />
                      </div>
                    )}
                    <Shimmer
                      loading={!state.baseInfo}
                      loadingComponent={
                        <ContainerBox shimmer={isMobileDevice}>
                          {!isMobileDevice && (
                            <div className={styles.loaderWrapper}>
                              <div>
                                <Line
                                  count={2}
                                  sameWidth={false}
                                  width={400}
                                  height={20}
                                />
                                <br />
                                <br />
                                <Box height={60} width={200} />
                              </div>
                              <Line
                                count={2}
                                sameWidth={false}
                                width={500}
                                height={20}
                              />
                            </div>
                          )}
                        </ContainerBox>
                      }
                      renderComponent={
                        <>
                          {state.baseInfo ? (
                            state.baseInfo.status === Webinar_status.ENDED ? (
                              <div></div>
                            ) : state.baseInfo.livestreamStatus ===
                              LIVESTREAM_status.ACTIVE ? (
                              state.baseInfo.sourceType ===
                                SourceType.SOURCE_MUX && (
                                <>
                                  <MuxVideoPlayer
                                    showPlayer={true}
                                    isSidePanelOpen={isOpen}
                                    closeStartWatchingBtn={
                                      closeStartWatchingBtn
                                    }
                                    videoData={state.baseInfo}
                                    muxVideoRef={muxVideoRef}
                                    themeType={THEME.EVENT_THEME}
                                    handleVideoLoading={handleVideoLoading}
                                  />
                                  <div
                                    style={{
                                      zIndex:
                                        isFullScreen && showVideoOverlay
                                          ? 2
                                          : 0,
                                      display: isFullScreen ? "block" : "none",
                                    }}
                                  >
                                    <WebinarHeader
                                      details={state.baseInfo}
                                      isOpen={isOpen}
                                      setIsOpen={setIsOpen}
                                      showPollIndicator={showPollIndicator}
                                      overlay
                                    />
                                  </div>
                                </>
                              )
                            ) : state.baseInfo.livestreamStatus ===
                              LIVESTREAM_status.IDLE ? (
                              <img
                                src={state.baseInfo.thumbnailUrl}
                                alt={"videoPlaceholder"}
                              />
                            ) : (
                              <div className={styles.placeholderWrapper}>
                                <div className={styles.loader}>
                                  <img src={LoaderImg} alt="loading..." />
                                </div>
                                <img
                                  src={state.baseInfo.thumbnailUrl}
                                  alt={"videoPlaceholder"}
                                />
                              </div>
                            )
                          ) : null}

                          {state.baseInfo.sourceType ===
                            SourceType.SOURCE_YOUTUBE && (
                            <ReactPlayer
                              height="100%"
                              width="100%"
                              style={{ position: "absolute" }}
                              url={state.baseInfo.youtubeURL}
                              config={{
                                youtube: {
                                  playerVars: {
                                    showinfo: 0,
                                    controls: 0,
                                    disablekb: 0,
                                    enablejsapi: 0,
                                    modestbranding: 0,
                                    rel: 0,
                                    playsinline: 1,
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      }
                    />
                    {/* {!isOpen && (
                      <div
                        onClick={() => setIsOpen(true)}
                        className={styles.qAimg}
                        style={{
                          zIndex: showVideoOverlay ? 2 : 0,
                        }}
                      >
                        {showPollIndicator && (
                          <div className={styles.pollQAIndicator} />
                        )}
                        <img src={QNAImg} alt="" />
                      </div>
                    )} */}
                    <div
                      style={{
                        zIndex: showVideoOverlay ? 2 : 0,
                      }}
                    >
                      <InteractionContainer
                        agenda={state.agenda}
                        eventDetails={state.baseInfo}
                      />
                    </div>
                  </div>
                }
                sideComponent={
                  <PollsNQnA
                    setPollIndicator={setPollIndicator}
                    details={state.baseInfo}
                    qnaToggle={setIsOpen}
                    showTabDirectly={showDefaultTabPolls}
                    setShowTabDirectly={setShowDefaultTabPolls}
                  />
                }
                sideOpen={isOpen}
              />
              <div className={styles.details}>
                <Shimmer
                  loading={false}
                  loadingComponent={
                    <div>
                      <div className={styles.row}>
                        <div className={styles.row}>
                          <Circle radius={100} />
                          <div
                            style={{
                              marginLeft: "1.25rem",
                            }}
                          >
                            <Line
                              count={2}
                              height={15}
                              width={300}
                              sameWidth={false}
                            />
                            <Line height={10} width={300} sameWidth={false} />
                          </div>
                        </div>
                        <Box width={150} height={70} />
                      </div>
                      <div
                        className={styles.row}
                        style={{
                          marginTop: 30,
                          marginLeft: 120,
                        }}
                      >
                        <Box width={300} height={70} />
                      </div>
                    </div>
                  }
                  renderComponent={
                    <WebinarHeader
                      details={state.baseInfo}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      showPollIndicator={showPollIndicator}
                    />
                  }
                />
              </div>
            </>
          )}
          {user &&
            state.baseInfo &&
            state.baseInfo.status === Webinar_status.ONGOING && (
              <ChatBot webinarDetails={state.baseInfo} />
            )}
          <div className={styles.tabsData}>
            <WebinarTabs setShowTabDirectly={setShowDefaultTabPolls} />
          </div>
        </div>
        {!speedControlOpen && (
          <div className={`${styles.sectionWrapper} ${styles.footerWrapper}`}>
            <ContactFooter zIndexZero />
          </div>
        )}
      </div>
    </WebinarPageContext.Provider>
  );
}

export default WebinarDetails;
